import { custom_event_handler } from "./EventHandlers";

export const eventTarget = new EventTarget();

eventTarget.addEventListener('custom_event', custom_event_handler);

export const dispatchCustomEvent = (event) => {
    eventTarget.dispatchEvent(new CustomEvent(event.class, { detail: event.event }))
};
